import lod_ from "lodash";
import {
	Chip,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	List,
	ListItem,
	ListItemText
} from "@mui/material";
import { useEffect, useState } from "react";
import FormAction from "redux-react/actions/formAction";
import { useDispatch } from "react-redux";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import MDButton from "components/Basics/MDButton";
import { t } from "i18next";

/**
 * Dialog to launch the scrap of reviews for a given resource
 * Allows to choose the date from which we want to scrap reviews
 * @param {boolean} open - If the dialog is open or not
 * @param {function} onClose - Function to call to close the dialog
 * @param {function} perform - Function to call to perform the action
 * @param {object} resource - The resource on which we want to scrap reviews
 * @param {object} action - The action to perform
 * @param {object|array} values - The values on which we want to perform the action
 * @returns {JSX.Element} - The DeleteCampaign component
 */
const DeleteCampaign = ({ open, onClose, perform, resource, action, values }) => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const [checkState, setCheckState] = useState(false);

	const [numberOfPhone, setNumberOfPhone] = useState(null);
	const [numberOfEmail, setNumberOfEmail] = useState(null);
	const [numberOfContact, setNumberOfContact] = useState(null);

	const [listOfCapaign, setListOfCapaign] = useState([]);

	const handleClose = () => {
		setListOfCapaign([]);
		onClose();
	};

	const handleCheckState = campaings => {
		const uniqueStates = campaings.every(item => item.state === "canceled");

		if (uniqueStates) {
			setCheckState(true);
		} else {
			setCheckState(false);
		}

		const nbrPhone = lod_.sumBy(
			campaings,
			item => lod_.filter(item.contacts ?? [], c => c?.phone && c.phone.trim() !== "").length
		);
		const nbrEmail = lod_.sumBy(
			campaings,
			item => lod_.filter(item.contacts, c => c?.email && c.email.trim() !== "").length
		);
		const nbrContracts = lod_.sumBy(campaings ?? [], "numberOfContract");

		setNumberOfPhone(nbrPhone ?? null);
		setNumberOfEmail(nbrEmail ?? null);
		setNumberOfContact(nbrContracts ?? null);
	};

	const stateColors = {
		created: "#5cb85c",
		canceled: "#d9534f"
	};

	useEffect(() => {
		if (open === true && resource?.storage?.collection && values?.id_coupure) {
			setLoading(true);
			dispatch(
				FormAction.getItemsFromCollection(
					resource?.storage?.collection,
					{
						query: { id_coupure: values.id_coupure },
						projection: {
							_id: 0,
							state: 1,
							nom_voie: 1,
							numero: 1,
							commune: 1,
							code_postal: 1,
							startDate: 1,
							endDate: 1,
							cause: 1,
							contacts: 1,
							numberOfContract: 1
						}
					},
					res => {
						if (!lod_.isNil(res.items) && !lod_.isEmpty(res.items)) {
							setListOfCapaign(res.items);
							setLoading(false);
							handleCheckState(res.items);
						} else {
							setListOfCapaign([]);
							setCheckState(false);
							setLoading(false);
						}
					}
				)
			);
		} else {
			setListOfCapaign([]);
			setCheckState(false);
		}
	}, [open]);

	return (
		<Dialog open={open} onClose={handleClose}>
			<DialogTitle>{t("FORMS.RESOURCE.campaignTitleDelete")}</DialogTitle>
			<DialogContent>
				{loading && (
					<MDBox display="flex" justifyContent="center" alignItems="center">
						<CircularProgress color="info" size={24} />
					</MDBox>
				)}

				{!loading && checkState && (
					<>
						<MDBox mb={2}>
							{values?.cause && (
								<MDBox display="flex">
									<MDBox mr={1}>{t("FORMS.RESOURCE.campaignCause")}</MDBox>
									<MDTypography variant="subtitle2" color="text">
										{values?.cause}
									</MDTypography>
								</MDBox>
							)}
							{!lod_.isNil(listOfCapaign) && (
								<MDBox display="flex">
									<MDBox mr={1}>{t("FORMS.RESOURCE.campaignNumberAdress")}</MDBox>
									<MDTypography variant="subtitle2" color="text">
										{listOfCapaign?.length}
									</MDTypography>
								</MDBox>
							)}
							{!lod_.isNil(numberOfPhone) && (
								<MDBox display="flex">
									<MDBox mr={1}>{t("FORMS.RESOURCE.campaignNumberPhone")}</MDBox>
									<MDTypography variant="subtitle2" color="text">
										{numberOfPhone}
									</MDTypography>
								</MDBox>
							)}
							{!lod_.isNil(numberOfEmail) && (
								<MDBox display="flex">
									<MDBox mr={1}>{t("FORMS.RESOURCE.campaignNumberEmail")}</MDBox>
									<MDTypography variant="subtitle2" color="text">
										{numberOfEmail}
									</MDTypography>
								</MDBox>
							)}
							{!lod_.isNil(numberOfContact) && (
								<MDBox display="flex">
									<MDBox mr={1}>{t("FORMS.RESOURCE.campaignNumberContact")}</MDBox>
									<MDTypography variant="subtitle2" color="text">
										{numberOfContact}
									</MDTypography>
								</MDBox>
							)}

							{!lod_.isNil(action?.config?.state) && (
								<MDBox display="flex">
									<MDBox mr={1}>{t("FORMS.RESOURCE.changeStateInfo")}</MDBox>
									<MDTypography variant="subtitle2" color="text">
										{t(`FORMS.RESOURCE.${action?.config.state}`)}
									</MDTypography>
								</MDBox>
							)}
						</MDBox>

						<MDBox>{t("FORMS.RESOURCE.campaignSelectionInfo")}</MDBox>
						<List sx={{ width: "100%", bgcolor: "background.paper" }}>
							{listOfCapaign.map(value => (
								<ListItem key={value} disableGutters>
									<ListItemText
										secondary={
											<MDBox display="flex" alignItems="center">
												<Chip
													size="small"
													variant="outlined"
													style={{ backgroundColor: stateColors[value?.state] || "#191919" }}
													label={t(`FORMS.RESOURCE.${value?.state}`)}
												/>
												<MDBox ml={1}>
													{[value?.numero, value?.nom_voie, value?.commune, value?.code_postal]
														.filter(Boolean)
														.join(" ")}
												</MDBox>
											</MDBox>
										}
									/>
								</ListItem>
							))}
						</List>
					</>
				)}

				{!checkState && (
					<MDTypography variant="subtitle2" color="text">
						{t("FORMS.RESOURCE.campaignError")}
					</MDTypography>
				)}
			</DialogContent>
			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={handleClose}>
					{t("SETTINGS.cancel")}
				</MDButton>
				<MDButton
					variant="contained"
					color="info"
					disabled={!checkState}
					onClick={() => {
						const copyAction = lod_.cloneDeep(action);
						lod_.set(copyAction, "config.id_coupure", values?.id_coupure);

						if (!Array.isArray(values)) {
							values = [values];
						}
						perform(copyAction, values);
						onClose();
					}}
				>
					{t("SETTINGS.confirm")}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteCampaign;
